import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import RedBox from 'redbox-react';
import styled from 'styled-components';
import { Spin } from 'antd';
import Sidebar from './Sidebar';
import {
  tmRoutes,
  nsRoutes,
  crsRoutes,
  trmRoutes,
  CMRoutes,
  sandboxRoutes
} from '../../routes';
import Topbar from './Topbar';
import Footbar from './Footbar';
import {
  fetchAppContext,
  postLogoutRequest
} from '../../redux/actions/authentication';
import style from './index.scss';
import { getCurrentAppByPath, getAppName } from './appUtils';
import {
  crsHasPermission,
  nsHasPermission,
  sandboxHasPermission,
  tmHasPermission
} from '../../util';
// import loadable from '@loadable/component';

export const LoadingWrapper = styled.div`
  position: absolute;
  z-index: 10000;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.3);
`;

// const LoadableNopp = loadable(() => import('nopp'));

class App extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);

    this.state = {
      menuCollaps: true,
      selectedItem: 1,
      emerging: true,
      appError: null
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.changeActiveItem = this.changeActiveItem.bind(this);
    this.onPostLogout = this.onPostLogout.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.switchApp = this.switchApp.bind(this);
  }

  static getDerivedStateFromProps(nextProps) {
    const { app } = nextProps;

    if (app && app.tmMetadataResp) {
      const tmMetadata = app.tmMetadataResp.data;
      localStorage.setItem('tm_metadata', JSON.stringify(tmMetadata));
    }
    return null;
  }

  toggleMenu() {
    this.setState({
      menuCollaps: !this.state.menuCollaps
    });
  }

  changeActiveItem(id) {
    this.setState({
      ...this.state,
      selectedItem: id
    });
  }

  onPostLogout() {
    this.props.postLogout({
      token: localStorage.getItem('id_token')
    });
  }

  onDismiss() {
    this.setState({
      ...this.state,
      emerging: false
    });
  }

  switchApp(selectedModule) {
    const { authentication } = this.props;
    const isTMAllowed = tmHasPermission(authentication);
    const isNSAllowed = nsHasPermission(authentication);
    const isCRSAllowed = crsHasPermission(authentication);
    const isSandboxAllowed = sandboxHasPermission(authentication);

    if (isTMAllowed && selectedModule == 'tm') {
      this.props.navigateTo('/app/tm');
    }
    if (isNSAllowed && selectedModule == 'smart-screening') {
      this.props.navigateTo('/app/smart-screening');
    }
    if (isCRSAllowed && selectedModule == 'crs') {
      this.props.navigateTo('/app/crs');
    }
    if (isSandboxAllowed && selectedModule == 'sandbox') {
      this.props.navigateTo('/app/sandbox');
    }

    if (selectedModule == 'cm') {
      this.props.navigateTo('/app/cm');
    }
  }

  onPageError = () => {
    window.location.reload();
  };

  onShowMore = () => {
    if (this.state.timeOut) {
      clearTimeout(this.state.timeOut);
    }
  };

  componentDidMount() {
    const {
      dispatch,
      authentication: { data }
    } = this.props;

    if (!data) {
      dispatch(fetchAppContext());
    }

    // LoadableNopp.load();
  }

  componentDidUpdate(prevProps) {
    const {
      authentication: { currentProductLogin },
      location
    } = this.props;

    if (currentProductLogin !== prevProps.authentication.currentProductLogin) {
      const moduleName = getAppName(currentProductLogin)?.toLowerCase();

      if (moduleName !== '' && moduleName !== '404') {
        this.switchApp(moduleName);

        this.setState({
          ...this.state,
          selectedItem: getActiveSidebarByPath(location.pathname),
          timeOut: setTimeout(this.onDismiss, 10000)
        });
      }
    }
  }

  componentDidCatch(error, info) {
    this.setState({
      ...this.state,
      appError: error
    });
  }

  componentWillUnmount() {
    clearTimeout(this.state.timeOut);
  }

  render() {
    const { app, location, authentication } = this.props;
    const { appError } = this.state;
    const {
      authentication: { currentProductLogin }
    } = this.props;
    const moduleName = getAppName(currentProductLogin)?.toLowerCase();

    const isAppLoader =
      authentication.productLogin?.isInProgress ||
      authentication.userModules?.isInProgress ||
      authentication.changeRole?.isInProgress;

    if (appError && process.env.mode == 'dev') {
      return <RedBox error={appError} />;
    }

    return (
      <div className={style.wrapper}>
        {isAppLoader ? (
          <LoadingWrapper>
            <Spin size="large" />
          </LoadingWrapper>
        ) : null}
        <Sidebar
          location={location}
          appName={moduleName}
          selectedItem={this.state.selectedItem}
          menuCollaps={this.state.menuCollaps}
          changeActiveItem={this.changeActiveItem}
          toggleMenu={this.toggleMenu}
          navigateTo={this.props.navigateTo}
          authentication={authentication}
        />
        <Topbar
          authentication={authentication}
          location={location}
          appName={moduleName}
          menuCollaps={this.state.menuCollaps}
          postLogout={this.onPostLogout}
          onSwitchApp={this.switchApp}
          isLoading={app.isFetching}
        />
        <div
          className={
            this.state.menuCollaps
              ? style.mainContentCollaps
              : style.mainContent
          }>
          {/* {false && appName == 'tm' ? (
            <DismissBar
              type="ALERT"
              message=" For segment 'SG-PFS', the number of alerts produced in the past month is 50% above the monthly average."
              cb={this.onDismiss}
              onShowMore={this.onShowMore}
            />
          ) : (
            ''
          )} */}
          {moduleName == 'smart-screening' && nsRoutes(authentication)}
          {moduleName == 'tm' && tmRoutes(authentication)}
          {moduleName == 'crs' && crsRoutes(authentication)}
          {(moduleName == 'trm' || moduleName == 'tm') &&
            trmRoutes(authentication)}
          {/* TODO: Check if sandbox module name check is required */}
          {moduleName == 'sandbox' && sandboxRoutes(authentication)}
          {moduleName == 'cm' && <CMRoutes authentication={authentication} />}
        </div>
        <Footbar />
      </div>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  authentication: PropTypes.object.isRequired,
  navigateTo: PropTypes.func,
  postLogout: PropTypes.func
};

const getActiveSidebarByPath = (path) => {
  if (path.indexOf('investigation') >= 0) return 2;

  return 1;
};

function mapStateToProps(state, ownProps = {}) {
  return {
    app: state.app,
    authentication: state.authentication,
    location: state.router.location
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch,
    navigateTo: (location) => {
      dispatch(push(location));
    },
    postLogout: (payload) => {
      dispatch(postLogoutRequest(payload));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
